import {
  DomainMessagesTypes,
  isDataChanged,
  isFailUploadedMessage,
  isPullFailedMessage,
  type Message,
} from 'shared/domain/messages/message';
import { EntityEventReaction, type EntityEventOutcome } from './types';

/**
 * What an event of an entity channel means for its store. `readCollection`
 * comes from the entity client, so the store never checks message types itself.
 * A failed upload only reloads here: a pending change's command rejects with
 * the error and its caller tells the user; the store's actions report the
 * failures nobody waits for.
 */
export function classifyEntityEvent<TModel>(
  event: Message,
  readCollection: (event: Message) => TModel[] | undefined
): EntityEventOutcome<TModel> {
  const collection = readCollection(event);
  if (collection) {
    return { reaction: EntityEventReaction.applyCollection, items: collection };
  }
  if (isPullFailedMessage(event)) {
    return { reaction: EntityEventReaction.stopLoading };
  }
  if (
    isFailUploadedMessage(event) ||
    event.type === DomainMessagesTypes.clearData ||
    event.type === DomainMessagesTypes.tableChanged ||
    (Boolean(event.data) && isDataChanged(event))
  ) {
    return { reaction: EntityEventReaction.reload };
  }
  return { reaction: EntityEventReaction.ignore };
}
